import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import classnames from 'classnames/bind';

import Header from '@COMPONENTS/HEADERS/Header';
import MainHeader from '@COMPONENTS/HEADERS/MainHeader';
import Subheader from '@COMPONENTS/HEADERS/Subheader';
import StepSidebar from '@COMPONENTS/SIDEBARS/StepSidebar';

import styles from './GenerateDocument.module.scss';

const cx: CX = classnames.bind(styles);

// Pages that handle their own specialized sidebars
const PAGES_WITH_CUSTOM_SIDEBARS = [
    '/preview',
    '/download-document'
];

function GenerateDocumentLayout() {
    const location = useLocation();
    const hasCustomSidebar = PAGES_WITH_CUSTOM_SIDEBARS.includes(location.pathname);

    return (
        <>
            <Header>
                <MainHeader />
                <Subheader title="Generate New Document" />
            </Header>

            <main className={cx('main')}>
                <div className="container max-constraint center">
                    <div className={cx('modern-layout', { 'no-sidebar': hasCustomSidebar })}>
                        {!hasCustomSidebar && <StepSidebar />}
                        <div className={cx('content-card')}>
                            <Outlet />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

export default GenerateDocumentLayout;
